"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExportFinished = void 0;
// (C) 2007-2019 GoodData Corporation
var errors_1 = require("../constants/errors");
function isExportFinished(responseHeaders) {
    var taskState = responseHeaders.status;
    return taskState === errors_1.SUCCESS_REQUEST_STATUS || taskState >= errors_1.BAD_REQUEST_STATUS; // OK || ERROR
}
exports.isExportFinished = isExportFinished;
//# sourceMappingURL=export.js.map